// extracted by mini-css-extract-plugin
export default {"container_ingredient":"Ingredient_container_ingredient__h4She","container_price":"Ingredient_container_price__5XQxZ","name":"Ingredient_name__lWDz+","link":"Ingredient_link__PJSRI"};